import React, { useState, useContext } from 'react';
import { Header, Container, Segment, Grid, Divider } from 'semantic-ui-react';
import { List, Label, Button, Icon, Modal, Select, Form, Dropdown, Menu } from 'semantic-ui-react';
import { Link, useParams, Redirect } from 'react-router-dom';
import { AppState } from '../context';
import { Loader, Dimmer } from 'semantic-ui-react';
import { dbPending, dbFamMember, dbFamtoFam } from '../firebase';
import TopMenu from './TopMenu';

const Notes = () => {
  const someContext = useContext(AppState);
  const {
    filter,
    globallogged,
    pending,
    familyMembers,
    tasks,
    caregivers,
    famtofam,
    filter2nd,
    filtermine,

  } = someContext;


  const [loader, setLoader] = useState(true);
  setTimeout(() => { setLoader(false) }, 500)
  let { userid } = useParams();

  function EachItem1({ id }) {
    var temp;

    var date = new Date(tasks[id]["statusLastChecked"]);
    console.log(date)
    temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
    if (date.getMinutes() < 10) {
      temp = temp + "0" + date.getMinutes().toString();
    } else {
      temp = temp + date.getMinutes().toString();
    }


    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' color='green' ribbon>
              Completed
        </Label>
            <span><strong>{tasks ? tasks[id]["taskName"] : ""}</strong></span>
            <List.Item> <strong>Description:</strong> {tasks ? tasks[id]["description"] : ""}</List.Item>
            {/* <List.Item> <strong>Duration:</strong> {tasks ? tasks[id]["duration"] : ""}</List.Item> */}
            {/* <List.Item> <strong>Caregiver Notes:</strong> {"137/84, Pulse: 65"}</List.Item> */}

            <List.Item> <strong>Checked On: </strong> {tasks ? temp : ""}</List.Item>
          </Segment>
        </Grid.Column>
      </Grid.Row>);
  }
  function EachItem2({ id }) {

    var temp;

    var date = new Date(tasks[id]["createdOn"]);
    temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
    if (date.getMinutes() < 10) {
      temp = temp + "0" + date.getMinutes().toString();
    } else {
      temp = temp + date.getMinutes().toString();
    }




    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' ribbon>
              Incomplete
        </Label>
            <span><strong>{tasks ? tasks[id]["taskName"] : ""}</strong></span>
            <List.Item> <strong>Description:</strong> {tasks ? tasks[id]["description"] : ""}</List.Item>
            <List.Item> <strong>Created On: </strong> {tasks ? temp : ""}</List.Item>

            {/* <List.Item> <strong>Duration:</strong> {tasks ? tasks[id]["duration"] : ""}</List.Item> */}
          </Segment>
        </Grid.Column>
      </Grid.Row>);
  }
  function EachItemC1({ id }) {
    var temp;

    var date = new Date(id["statusLastChecked"]);
    temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
    if (date.getMinutes() < 10) {
      temp = temp + "0" + date.getMinutes().toString();
    } else {
      temp = temp + date.getMinutes().toString();
    }


    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' color='green' ribbon>
              Completed
        </Label>
            <span><strong>{id ? id["type"] : ""}</strong></span>
            <List.Item> <strong>Description:</strong> {id ? id["detail"] : ""}</List.Item>
            <List.Item> <strong>Completed on :</strong> {id ? temp : ""}</List.Item>
            {/* <List.Item> <strong>Caregiver Notes:</strong> {"137/84, Pulse: 65"}</List.Item> */}
          </Segment>
        </Grid.Column>
      </Grid.Row>);
  }
  function EachItemC2({ id }) {
    var temp;

    var date = new Date(id["createdOn"]);
    temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
    if (date.getMinutes() < 10) {
      temp = temp + "0" + date.getMinutes().toString();
    } else {
      temp = temp + date.getMinutes().toString();
    }
    if (!id['sample']) {
      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' ribbon>
                Incomplete
        </Label>
              <span><strong>{id ? id["type"] : ""}</strong></span>
              <List.Item> <strong>Description:</strong> {id ? id["detail"] : ""}</List.Item>
              <List.Item> <strong>Assigned on :</strong> {id ? temp : ""}</List.Item>
              {/* <List.Item> <strong>Duration:</strong> {id ? id["time"] : ""}</List.Item> */}

            </Segment>
          </Grid.Column>
        </Grid.Row>);


    }
    return ("")
  }
  function EachItemF1({ id }) {

    if (famtofam[id]["status"]) {
      var temp;
      var date = new Date(famtofam[id]["createdOn"]);
      console.log(date)
      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      }

      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' color='green' ribbon>
                Completed
        </Label>
              <span><strong>{famtofam ? famtofam[id]["taskName"] : ""}</strong></span>
              <List.Item> <strong>Description:</strong> {famtofam ? famtofam[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Completed  on:</strong> {temp}</List.Item>

              {/* <List.Item> <strong>Duration:</strong> {famtofam ? famtofam[id]["duration"] : ""}</List.Item> */}
              {/* <List.Item> <strong>Caregiver Notes:</strong> {"137/84, Pulse: 65"}</List.Item> */}
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else if (!famtofam[id]["status"]) {
      var temp;
      var date = new Date(famtofam[id]["createdOn"]);

      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      } return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' ribbon>
                Incomplete
        </Label>
              <span><strong>{famtofam ? famtofam[id]["taskName"] : ""}</strong></span>
              <List.Item> <strong>Description:</strong> {famtofam ? famtofam[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Assigned  on:</strong> {temp}</List.Item>

              {/* <List.Item> <strong>Duration:</strong> {famtofam ? famtofam[id]["duration"] : ""}</List.Item> */}
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else {
      return null;
    }
  }
  function EachItemU1({ id }) {
    const [confirmmodal, setConfirmModal] = useState(false)
    function FirebaseRewrite() {
      if (familyMembers && pending[id] && pending[id]["AssignedbyFam"]) {
        temp = pending[id];
        temp["AssignedtoFam"] = userid;
        if (familyMembers[pending[id]["AssignedbyFam"]] && familyMembers[pending[id]["AssignedtoFam"]]) {
          console.log(id)
          if (Object.keys(pending).length > 1) {
            dbPending.child(id).remove();
            if (Object.values(familyMembers[userid]["unassignedTasks"]).length == 1) {
              console.log("if: ", familyMembers[userid])
              dbFamMember.child(userid).child("unassignedTasks").child(id).remove()
              dbFamMember.child(userid).update({
                "unassignedTasks": "null",
              })
            }
            else {
              console.log(familyMembers[userid])
              dbFamMember.child(userid).child("unassignedTasks").child(id).remove()
            }
          }
          const dataToPush = {
            [id]: temp
          }
          dbFamtoFam.update(dataToPush);
          if (familyMembers[pending[id]["AssignedtoFam"]]["tasksfromfam"]) {
            dbFamMember.child(userid).child("tasksfromfam").update({
              [id]: id || null
            });
          }
          else {
            dbFamMember.child(userid).child("tasksfromfam").update({
              [id]: id || null
            });
          }
        }
      }
      else {
        console.log("Doesnt work")
      }
      setConfirmModal(false);
    }
    if (pending[id]["status"]) {
      var temp;
      var date = new Date(pending[id]["createdOn"]);
      console.log(date)
      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      }

      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' color='green' ribbon>Completed</Label>
              <strong>{pending ? pending[id]["taskName"] : ""}</strong>
              <List.Item> <strong>Description:</strong> {pending ? pending[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Completed on:</strong> {temp}</List.Item>
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else if (!pending[id]["status"]) {
      var temp;
      var date = new Date(pending[id]["createdOn"]);
      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      } return (

        <Grid.Row>
          <Modal open={confirmmodal} size='small' closeOnEscape={true} basic >
            <Header icon='archive' />
            <Modal.Content>
              Do you want to add <strong>{pending ? pending[id]["taskName"] : ""}</strong> to your tasklist?
            </Modal.Content>
            <Modal.Actions>
              <Button basic color='red' inverted onClick={() => setConfirmModal(false)}>
                <Icon name='remove' /> No</Button>
              <Button color='green' inverted onClick={() => FirebaseRewrite()}>
                <Icon name='checkmark' /> Yes</Button>
            </Modal.Actions>
          </Modal>
          <Grid.Column>
            <Segment raised onClick={() => setConfirmModal(true)}>
              <Label as='a' ribbon>
                Incomplete</Label>
              <span><strong>{pending ? pending[id]["taskName"] : ""}</strong></span>
              <List.Item> <strong>Description:</strong> {pending ? pending[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Assigned  on:</strong> {temp}</List.Item>
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else {
      return null;
    }
  }
  const TasksFromFam = () => {
    if (familyMembers[userid]["tasksfromfam"] && filtermine) {
      return (Object.values(familyMembers[userid]["tasksfromfam"]).map((id) =>
        <EachItemF1 id={id} />))
    } else {
      return null;
    }

  }

  function Loaded() {

    function helper2(note){
        if(Object.values(note)!="n" && Object.values(note)!="u" && Object.values(note)!="l"){
          return(
            <Grid.Row>
            <Grid.Column>
              <Segment raised>
              <Label as='a' ribbon>
              {note["category"]}
        </Label>
            <span><strong>{note["title"]}</strong></span>
            <List.Item> <strong>{note["description"]}</strong></List.Item>
            {/* <List.Item> <strong>Created On: </strong> {tasks ? temp : ""}</List.Item> */}
              </Segment>
        </Grid.Column>
      </Grid.Row>
        );
          }
          else{
            return null;
          }
    }
    function helper(caregiverid){
        if (caregivers){
            return (Object.values(caregivers[caregiverid]["notes"]).map((note)=>helper2(note)));
        }
    }
    if (globallogged && familyMembers[userid]['careBool'])
    {
    return (
      tasks && famtofam && caregivers && familyMembers ?
        <div>
          <TopMenu />
          <Container>
            {console.log(filter, filter2nd)}
            <Grid padded>
             {Object.values(familyMembers[userid]["caregivers"]).map((id)=>helper(id))}
             
            </Grid>
          </Container>
        </div> :
        <Dimmer active>
          <Loader size='huge'>Loading</Loader>
        </Dimmer>
    )}
    else 
    // if (globallogged)
    {
      return( tasks && famtofam && caregivers && familyMembers ? <div>
      <TopMenu />
      <Container>
       
        <Header textAlign="center" style={{marginTop:"10px"}}> No Caregiver set up yet! Add one by going to settings and clicking 'Add Caregiver' and they will be able to add daily updates and medical updates for you here.</Header>
      </Container>
    </div> :
    <Dimmer active>
      <Loader size='huge'>Loading</Loader>
    </Dimmer>);

    }
    // else{
    //   return <Redirect to={'/login'} push={true} />
    // }
  }
  return (<div>
    {loader ?
      <Dimmer active>
        <Loader size='huge'>Loading</Loader>
      </Dimmer> : <Loaded />}
  </div>);
}

export default Notes;